import types from '../actionTypes';

export const pinsRequest = meta => ({
    type: types.PINS_REQUEST,
    meta,
});

export const pinsRequestCompleted = () => ({
    type: types.PINS_REQUEST_COMPLETED,
});

export const pinsDetailRequest = id => ({
    type: types.PINS_DETAIL_REQUEST,
    meta: { id },
});

export const pinsDetailRequestCompleted = () => ({
    type: types.PINS_DETAIL_REQUEST_COMPLETED,
});
